import React from 'react';

export default class BottomToolbar extends React.Component {
  render() {
    const { className = '', isFleek = false, innerContainerStyles={} } = this.props;
    return (
      <div
        className={`rilrtl-toolbar rilrtl-toolbar--fixed rilrtl-toolbar--bottom ${className}`}
        style={isFleek ? { background: '#2E343A' } : {}}
      >
        <div className="rilrtl-toolbar__row" style={{
          ...innerContainerStyles
        }}>{this.props.children}</div>
      </div>
    );
  }
}
